'use client';

import { createContext, useContext, type RefObject } from 'react';
import type { CameraFrame } from './scene/SkyCamera';
import type { SkyState } from './skyStore';

export interface SkyScrollFrame {
  rampIn: number;
  rampOut: number;
  reveal: number;
  progress: number;
}

export type SkyScrollListener = (frame: SkyScrollFrame) => void;

export interface SkyShellValue {
  ready: boolean;
  cameraFrameRef: RefObject<CameraFrame | null>;
  subscribeCamera: (listener: (camera: CameraFrame) => void) => () => void;
  setSkyState: (partial: Partial<SkyState>) => void;
  /** fires with the current frame on subscribe, then per scroll */
  subscribeScroll: (listener: SkyScrollListener) => () => void;
}

export const INITIAL_SCROLL_FRAME: SkyScrollFrame = {
  rampIn: 0,
  rampOut: 1,
  reveal: 0,
  progress: 0,
};

const noop = () => {};

export const SkyShellContext = createContext<SkyShellValue>({
  ready: false,
  cameraFrameRef: { current: null },
  subscribeCamera: () => noop,
  setSkyState: noop,
  subscribeScroll: () => noop,
});

export const useSkyShell = (): SkyShellValue => useContext(SkyShellContext);
